import { render, staticRenderFns } from "./OPDSpace.vue?vue&type=template&id=d18f02ea"
import script from "./OPDSpace.vue?vue&type=script&lang=js"
export * from "./OPDSpace.vue?vue&type=script&lang=js"
import style0 from "./OPDSpace.vue?vue&type=style&index=0&id=d18f02ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports